import api from "../service";
import { store } from "store/configureStore";
import { hotToast } from "utils";

export const getBrands = async (idBrand: number) => {
  await api.setToken();
  let isValid: object | any | null = await api.requestGet(
    `Marca/GetMarcas?idMarca=${idBrand}`
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      return null;
    }
    return data.data;
  }
  return null;
};

export const addBrand = async (form: FormData) => {
  if (!form.get("idUsuarioAct")) {
    form.append("idUsuarioAct", store.getState().user.idUsuario);
  }
  await api.setToken();
  let isValid: object | any | null = await api.requestPost(
    `Marca/InsertMarca`,
    form
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    hotToast("La marca se dío de alta correctamente", "SUCCESS");
    return true;
  }
  data?.message && hotToast(data?.message,"ERROR");
  return null;
};

export const updateBrand = async (
  id: number,
  form: FormData,
  disableOrEnable?: boolean
) => {
  if (!form.get("idUsuarioAct")) {
    form.append("idUsuarioAct", store.getState().user.idUsuario);
  }
  await api.setToken();
  let isValid: object | any | null = await api.requestPut(
    `Marca/UpdateMarca/${id}`,
    form
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    let messageView = disableOrEnable
      ? `La marca se ${
          form.get("idEstatus") === "1" ? "activo" : "desactivo"
        } correctamente`
      : "La marca se actualizo correctamente";
    hotToast(messageView, "SUCCESS");
    return true;
  }
  data?.message && hotToast(data?.message,"ERROR");
  return null;
};
